module.exports = __webpack_public_path__ + "img/swipe4.2fcec3b4.png";